import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { translateVueDesktop } from '../i18n/vueDesktopMessages.js';

const fallbackLanguages = [
  { lang: 'zh', nativeName: '中文', title: '中文 / Chinese' },
  { lang: 'en', nativeName: 'English', title: 'English' },
  { lang: 'es', nativeName: 'Español', title: 'Español / Spanish' },
  { lang: 'fr', nativeName: 'Français', title: 'Français / French' },
  { lang: 'ru', nativeName: 'Русский', title: 'Русский / Russian' },
  { lang: 'ja', nativeName: '日本語', title: '日本語 / Japanese' },
  { lang: 'th', nativeName: 'ไทย', title: 'ไทย / Thai' },
  { lang: 'ko', nativeName: '한국어', title: '한국어 / Korean' },
  { lang: 'vi', nativeName: 'Tiếng Việt', title: 'Tiếng Việt / Vietnamese' },
  { lang: 'id', nativeName: 'Bahasa Indonesia', title: 'Bahasa Indonesia / Indonesian' },
  { lang: 'ms', nativeName: 'Bahasa Melayu', title: 'Bahasa Melayu / Malay' },
  { lang: 'fil', nativeName: 'Filipino', title: 'Filipino / Filipino' }
];

export function useLegacyI18n() {
  const api = window.AppI18n || null;
  const language = ref(api?.getLanguage?.() || 'en');
  const refreshLanguage = () => { language.value = api?.getLanguage?.() || 'en'; };

  onMounted(() => window.addEventListener('app-language-change', refreshLanguage));
  onBeforeUnmount(() => window.removeEventListener('app-language-change', refreshLanguage));

  const languages = computed(() => {
    language.value;
    return api?.getSupportedLanguageOptions?.() || fallbackLanguages;
  });
  const t = (key, fallback, vars) => {
    language.value;
    const vueValue = translateVueDesktop(language.value, key, vars);
    if (typeof vueValue === 'string') return vueValue;
    return api?.t?.(key, fallback, vars) || fallback || key;
  };
  const setLanguage = (next) => {
    language.value = api?.setLanguage?.(next) || next;
  };
  const agreementParagraphs = computed(() => {
    language.value;
    return api?.getAgreementParagraphs?.() || [];
  });
  const flagUrl = (lang, active) => api?.createLanguageFlagDataUrl?.(lang, {
    width: 48,
    height: 34,
    active
  }) || '';

  return { api, language, languages, t, setLanguage, agreementParagraphs, flagUrl };
}
